// Centralised MyAE social-media configuration.
//
// Single source of truth for every footer / contact / share surface.
// Adding or removing a platform here propagates everywhere automatically.
// A platform with `url === ""` is intentionally hidden until its channel
// goes live — the <SocialLinks /> component skips rendering it entirely
// (no empty <a>, no broken link, no disabled grey icon).

export const SOCIAL_LINKS = [
  {
    id: "facebook",
    label: "MyAE on Facebook",
    url: "https://www.facebook.com/profile.php?id=61594310060177",
  },
  {
    id: "instagram",
    label: "MyAE on Instagram",
    url: "https://www.instagram.com/myae.co.uk/",
  },
  {
    id: "tiktok",
    label: "MyAE on TikTok",
    url: "https://www.tiktok.com/@myae.co.uk",
  },
  {
    id: "linkedin",
    label: "MyAE on LinkedIn",
    url: "https://www.linkedin.com/company/my-academic-edge/",
  },
  {
    id: "youtube",
    label: "MyAE on YouTube",
    url: "", // intentionally blank until the official channel is live
  },
];

/** Returns only the platforms with a non-empty URL. */
export const activeSocialLinks = () => SOCIAL_LINKS.filter((s) => s.url);
